export const PROJECTS = [
  {
    id: "warehouse-brick-facade",
    name: "Distribution Centre Brick Facade",
    sector: "Industrial",
    description:
      "Full brick veneer facade for a new distribution centre, tying structural masonry into the building envelope.",
    image: "/images/project-01-warehouse-brick.jpg",
    imageAlt: "Completed brick veneer facade on an industrial distribution centre",
  },
  {
    id: "office-metal-siding",
    name: "Office Park Metal Siding Retrofit",
    sector: "Commercial",
    description:
      "Metal panel siding retrofit across a multi-building commercial office park, improving weatherproofing and curb appeal.",
    image: "/images/project-02-office-siding.jpg",
    imageAlt: "Commercial office building with newly installed metal siding panels",
  },
  {
    id: "retail-brick-restoration",
    name: "Retail Plaza Masonry Restoration",
    sector: "Commercial",
    description:
      "Structural re-pointing and brick facade restoration for an existing retail plaza, matching original masonry detailing.",
    image: "/images/project-03-retail-masonry.jpg",
    imageAlt: "Restored brick facade on a commercial retail plaza",
  },
  {
    id: "industrial-fiber-cement",
    name: "Manufacturing Facility Cladding",
    sector: "Industrial",
    description:
      "Fiber-cement cladding and building envelope upgrade for an active manufacturing facility, delivered on a live-site schedule.",
    image: "/images/project-04-industrial-cladding.jpg",
    imageAlt: "Industrial manufacturing facility with fiber-cement exterior cladding",
  },
  {
    id: "mixed-use-brick-siding",
    name: "Mixed-Use Development Exterior",
    sector: "Mixed-Use",
    description:
      "Combined brick veneer and siding envelope for a mixed-use commercial development, coordinated end-to-end by our project management team.",
    image: "/images/project-05-mixeduse.jpg",
    imageAlt: "Mixed-use commercial building exterior combining brick veneer and siding",
  },
  {
    id: "warehouse-expansion",
    name: "Warehouse Expansion & Envelope",
    sector: "Industrial",
    description:
      "Structural block work and exterior envelope for a warehouse expansion, planned and delivered under one project management team.",
    image: "/images/project-06-warehouse-expansion.jpg",
    imageAlt: "Warehouse expansion under construction showing block masonry and siding work",
  },
];
